<template>
	<div class="row problem" @click="toggleTime">
		<div class="time col-sm">{{problemTime}}</div>
		<div class="status has-problem col-sm" v-if="!problemSolved">ПРОБЛЕМА</div>
		<div class="status has-resolved col-sm" v-else>РЕШЕНО <span class="time">{{problemSolved}}</span></div>
		<div class="message">{{problem.message}}</div>
	</div>
</template>

<script>
import moment from 'moment'
moment.locale('ru')

export default {
	props: ['problem'],
	data() {
		return {
			timeInterval: true
		}
	},
	computed: {
		problemTime() {
			let time = moment.unix(this.problem.time)
			return this.timeInterval ? time.fromNow() : time.format('Y-MM-DD HH:mm:s')
		},

		problemSolved() {
			if (!this.problem.resolved)
				return false
			let time = 	moment.unix(this.problem.resolved)
			return this.timeInterval ? time.fromNow() : time.format('Y-MM-DD HH:mm:s')
		}
	},

	methods: {
		toggleTime() {
			this.timeInterval = !this.timeInterval
		}
	}
}
</script>

<style>

</style>
